/// <reference types="@types/googlemaps" />
import {Directive, ElementRef, EventEmitter, OnInit, Output} from '@angular/core';
import {AppHotelModel} from '../../../models/app-hotel.model';

@Directive({
  selector: '[ktGooglePlaces]'
})
export class GooglePlacesDirective implements OnInit {
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  private element: HTMLInputElement;
  hotel: AppHotelModel = new AppHotelModel();

  constructor(elRef: ElementRef) {
    this.element = elRef.nativeElement;
  }

  getFormattedAddress(place) {
    this.hotel = new AppHotelModel();
    this.element.value = place.name;
    localStorage.setItem('place_id', place.place_id);
    localStorage.setItem('lat', place.geometry.location.lat());
    localStorage.setItem('lng', place.geometry.location.lng());
    this.hotel.web_site_url = place.website;
    this.hotel.place_id = place.place_id;
    this.hotel.lat_lng = place.geometry.location.lat() + ',' + place.geometry.location.lng();
    this.hotel.address = place.formatted_address;
    this.hotel.contact_phone = place.formatted_phone_number;
    this.hotel.name = place.name;
    this.hotel.rating = place.rating;
    if (place.photos) {
      const urls = [];
      place.photos.forEach(x => {
        urls.push(x.getUrl());
      });
      for (const URL of urls) {
        this.hotel.photos += URL + ',';
      }
      this.hotel.photos.substring(0, -1);
      this.hotel.image_url = place.photos[0].getUrl();
    }
    place.address_components.forEach(item => {
      if (item['types'].indexOf('administrative_area_level_1') > -1) {
        this.hotel.city = item['short_name'];
      } else if (item['types'].indexOf('country') > -1) {
        this.hotel.country = item['long_name'];
      } else if (item['types'].indexOf('postal_code') > -1) {
        this.hotel.post_code = item['short_name'];
      }
    });
    return this.hotel;
  }

  ngOnInit() {
    const autocomplete = new google.maps.places.Autocomplete(this.element);
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      this.onSelect.emit(this.getFormattedAddress(autocomplete.getPlace()));
    });
  }
}
